const GROUP_CHIP_BASE =
  "inline-flex max-w-[8rem] truncate rounded-full border px-2 py-0.5 text-[0.6875rem] font-medium";

/** Subtle SaaS badge pairs. Index is assigned from a stable group-id hash. */
export const CONTACT_GROUP_COLOR_CLASSES = [
  "border-[rgb(191_219_254_/_0.7)] bg-[rgb(239_246_255)] text-[rgb(30_64_175)]",
  "border-[rgb(153_246_228_/_0.7)] bg-[rgb(240_253_250)] text-[rgb(17_94_89)]",
  "border-[rgb(221_214_254_/_0.7)] bg-[rgb(245_243_255)] text-[rgb(91_33_182)]",
  "border-[rgb(253_230_138_/_0.7)] bg-[rgb(255_251_235)] text-[rgb(146_64_14)]",
  "border-[rgb(254_205_211_/_0.7)] bg-[rgb(255_241_242)] text-[rgb(159_18_57)]",
  "border-[rgb(167_243_208_/_0.7)] bg-[rgb(236_253_245)] text-[rgb(6_95_70)]",
  "border-[rgb(203_213_225_/_0.8)] bg-[rgb(248_250_252)] text-[rgb(51_65_85)]",
  "border-[rgb(165_243_252_/_0.7)] bg-[rgb(236_254_255)] text-[rgb(21_94_117)]",
] as const;

function hashGroupId(id: number): number {
  let hash = id | 0;
  hash = Math.imul(hash ^ (hash >>> 16), 0x45d9f3b);
  hash = Math.imul(hash ^ (hash >>> 16), 0x45d9f3b);
  return (hash ^ (hash >>> 16)) >>> 0;
}

export function contactGroupColorIndex(id: number): number {
  return hashGroupId(id) % CONTACT_GROUP_COLOR_CLASSES.length;
}

export function contactGroupChipClassName(id: number): string {
  return `${GROUP_CHIP_BASE} ${CONTACT_GROUP_COLOR_CLASSES[contactGroupColorIndex(id)]}`;
}

export function contactGroupChipClassNameFromKey(key: string): string {
  let hash = 0;
  for (let index = 0; index < key.length; index += 1) {
    hash = Math.imul(31, hash) + key.charCodeAt(index);
  }
  return contactGroupChipClassName(hash);
}
